import React from "react";
import Table from "../../../../../../common/element/Table";
import moment from "moment/moment";
const { Tr, Th, Td, THead, TBody } = Table
const ClientCompliaceCheckList = ({ tableData, handleFilterSort, filtersort, filterorder }) => {
    return (
        <React.Fragment>
            <div className="overflow-hidden border rounded-lg border-gray-200">
                <Table>
                    <THead>
                        <Tr>
                            <Th>
                                <span className='flex items-center gap-1'>
                                    Client name
                                </span>
                            </Th>
                            <Th>Checklist name</Th>
                            <Th>Recipient</Th>
                            <Th>Documents no.</Th>
                            <Th>Completion rate</Th>
                            <Th onClick={(e) => handleFilterSort(e, 'date_joined')}>
                                <span className='flex items-center gap-1'>
                                    Publish date
                                    <svg className={`transform ${filtersort === "provider_count" &&
                                        filterorder === "asc"
                                        ? "rotate-180"
                                        : ""
                                        }`} width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8" stroke="#475467" stroke-width="1.333" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </Th>
                            <Th onClick={(e) => handleFilterSort(e, 'renewal_date')}>
                                <span className='flex items-center gap-1'>
                                    Renewal date
                                    <svg
                                        className={`transform ${filtersort === "renewal_date" &&
                                            filterorder === "asc"
                                            ? "rotate-180"
                                            : ""
                                            }`}
                                        width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8" stroke="#475467" stroke-width="1.333" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </Th>
                        </Tr>
                    </THead>
                    <TBody>
                        {tableData.length > 0 &&
                            tableData.map((item,index)=> {
                                return (
                                    <Tr key={index}>
                                    <Td>{item?.client_name}</Td>
                                    <Td>{item?.checklist_name}</Td>
                                    <Td>{item?.recipient_type? item.recipient_type.charAt(0).toUpperCase() + item.recipient_type.slice(1): ""} </Td>
                                    <Td>{item?.document_count}</Td>
                                    <Td>{item?.compliance_rate}</Td>
                                    {/* <Td>{moment(item?.date_joined).format("DD/MM/YYYY")}</Td>
                                    <Td>{moment(item?.renewal_date).format("DD/MM/YYYY")}</Td> */}
                                    <Td>{item?.date_joined}</Td>
                                    <Td>{item?.renewal_date}</Td>
                                </Tr>
                                )
                            })
                        }
                     
                    </TBody>
                </Table>
            </div>
        </React.Fragment>
    )
}
export default ClientCompliaceCheckList;